import React from 'react'
import { FrontMatter } from '../lib/models'
import ReturnLinkControl from '../controls/return-link-control'
import StickyHeader from './sticky-header'

interface IProps {
  frontMatter?: FrontMatter
}

class StateHeader extends React.Component<IProps> {

  renderLastUpdated() {
    if (!this.props.frontMatter?.updated) return <></>
    const date = new Date(this.props.frontMatter?.updated).toDateString()
    const by = this.props.frontMatter?.updatedBy
      ? ` by ${this.props.frontMatter.updatedBy}`
      : ''
    return (
      <p>
        Updated {date} {by}
      </p>
    )
  }

  render() {
    return (
      <StickyHeader stickyContent={this.props.children}>
        <h1>Joint Fuel Management Program</h1>  
      </StickyHeader>
    )
  }
}

export default StateHeader
